export default "/public/app-main/static/image/950d8ebf19ce25ee52285809f146d393.png";